import axios from 'axios';
import { getDatadogLogger } from '@storebrand-digital/common-datadog';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type Document from '../../Document';

export async function fetchProductDetails() {
  return axios
    .get('/customer/document/archive/documents/products')
    .then(({ data }) => data.payload)
    .catch((e) => {
      getDatadogLogger().error('Failed to fetch products', {}, e);
    });
}
export default function useProducts() {
  return useQuery<Document.ProductDetails[]>({
    queryKey: ['documents', 'products'],
    queryFn: fetchProductDetails,
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchInterval: 1000 * 60 * 60,
  });
}
